import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Dropdown, Form } from "react-bootstrap";
import { RedialChart } from "../charts";

export default function OrdersCardComponent({data}) {
  const { t, n } = useContext(TranslatorContext);
  const [filter, setFilter] = useState({
    filter: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const orders = [
    {
      name: new Date().toLocaleString("en-US", {
        month: "long",
        year: "numeric",
      }),
      value: 80,
      color: "purple",
      icon: "pending",
    },
    { name: "Oct- Nov - Dec", value: 250, color: "blue", icon: "add_circle" },
    {
      name: "Oct 2024 - Oct 2025",
      value: 1150,
      color: "green",
      icon: "check_circle",
    },
  ];

  return (
    <div className="mc-card">
      <div className="mc-card-header">
        <h4 className="mc-card-title">{t("FSF Families Rescue Target")}</h4>
        <Dropdown bsPrefix="mc-dropdown">
          <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
            <i className="material-icons">more_horiz</i>
          </Dropdown.Toggle>
          <Dropdown.Menu
            align="end"
            className="mc-dropdown-paper"
            style={{ width: "268px" }}
          >
            <Form.Group className="w-sm h-sm">
              <Form.Select
                name="filter"
                value={filter.filter}
                onChange={handleChange}
              >
                <option value="">Select Request ID</option>
                {data?.family_requests?.map((req)=>{
                  return(
                    <option value={req.id}>{req.rfq_id}</option>
                  )
                })}
              </Form.Select>
            </Form.Group>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <RedialChart />

      <ul className="mc-order-card-list">
        {orders.map((order, index) => (
          <li key={index} className="mc-order-card-item">
            <i className={`material-icons ${order.color}`}>{order.icon}</i>
            <p>{t(order.name)}</p>
            <h5>{n(order.value)} /100</h5>
          </li>
        ))}
      </ul>
    </div>
  );
}
